import { Modal } from "react-bootstrap";
import "./applicationsuccessmodal.scss";
import { inject, observer } from "mobx-react";
import cross from "images/cross.svg";
import success from "images/success.svg";
import iconError from "images/iconError.svg";

const ApplicationSuccessModal = ({
  errorWithoutDate,
  getCandidates,
  show,
  onHide
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="app-success-modal-wrapper">
        <p>
          <img src={cross} className="app-success-modal-crossimg" onClick={() => {
            getCandidates();
            onHide();
          }}
            alt="" />
        </p>
        <div className="app-success-modal">
          {errorWithoutDate ? (
            <>
              <p className="app-success-modal-title">Ваш отклик не отправлен</p>
              <p className="app-success-modal-text">{errorWithoutDate}</p>
              <img src={iconError} className="app-success-modal-img" onClick={onHide} alt="" />
            </>
          ) : (
            <>
              <p className="app-success-modal-title">Ваш отклик отправлен</p>
              <p className="app-success-modal-text">Проверить статус отклика можно в разделе “Мои кандидаты”</p>
              <img src={success} className="app-success-modal-img" onClick={() => {
                getCandidates();
                onHide();
              }}
                alt="" />
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ candidatesStore, vacanciesStore, modalWindows }) => {
  const { getApplicationsForCandidate, selectedCandidate, errorWithoutDate, cleanErrorWithoutDate, getCandidates } = candidatesStore;
  const { getVacancies_for_candidate } = vacanciesStore;
  const { setApplicationSuccessModal, setModalShowVacancies } = modalWindows;
  return {
    getApplicationsForCandidate,
    selectedCandidate,
    getVacancies_for_candidate,
    errorWithoutDate,
    cleanErrorWithoutDate,
    setApplicationSuccessModal,
    setModalShowVacancies,
    getCandidates
  };
})(observer(ApplicationSuccessModal));
